import React from 'react';

import Modal from 'shared/modals/Modal';
import LoadingSpinner from './LoadingSpinner';

const LoadingModal = ({ isOpen, isNested, text }) => (
  <Modal
    isOpen={isOpen}
    handleClose={() => {
      /* do nothing */
    }}
    backDropStyle={`margin--none light ${isNested ? 'nested' : ''}`}
    containerStyle='loading'
  >
    <LoadingSpinner text={text} />
  </Modal>
);

/**
 * @deprecated This component is deprecated and will be removed in future versions.
 * Please use the shared\components\indicators\LoaderSpinner\LoaderSpinner.jsx component instead.
 * as per https://dev.azure.com/gulfwinds/Gulf%20Winds%20Applications/_git/gulfwinds/pullRequest/4823#1728292102
 */
export default LoadingModal;
